<template>
  <layout-public>
    <page-meta />

    <page-hero
      :crumbs="heroCrumbs"
      :title="post.title"
      :meta="metaText"
    />

    <section v-if="post.cover_image" class="preview-cover">
      <div class="container">
        <div class="row">
          <div class="col">
            <img :src="post.cover_image" :alt="post.title" data-aos="zoom-in" />
          </div>
        </div>
      </div>
    </section>

    <section class="preview-content-section">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="prose" v-html="safeContent" data-aos="fade-up"></div>
          </div>
        </div>
      </div>
    </section>
  </layout-public>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.preview-cover {
  background: $ground-tint;
  padding-bottom: 0;
  padding-top: 2rem;

  img {
    border-radius: $r-sm;
    box-shadow: $shadow-card;
    display: block;
    height: auto;
    max-width: 100%;
    object-fit: contain;
    width: 100%;
  }
}

.preview-content-section {
  background: $ground-tint;
}

</style>

<script>
import { useI18n } from 'vue-i18n';
import DOMPurify from 'dompurify';
import PageMeta from '@/Components/PageMeta.vue';
import LayoutPublic from '@/Layouts/Public.vue';
import PageHero from '@/Components/PageHero.vue';

export default {
  components: {
    LayoutPublic,
    PageHero,
    PageMeta
  },

  props: {
    post: {
      type: Object,
      required: true
    }
  },

  computed: {
    safeContent() {
      return DOMPurify.sanitize(this.post.content || '');
    },

    /* The preview is reached by a signed link rather than through the site's
       navigation, so its single crumb names the page instead of pretending to
       be a path. It also replaces the "Content Preview" badge that used to sit
       above the title, which the hero chrome does not allow. */
    heroCrumbs() {
      return [{ label: this.t('Content Preview') }];
    },

    /* Date and author, the same meta line Blog/Show renders. */
    metaText() {
      const parts = [];
      if (this.post.created_at) parts.push(this.formatDate(this.post.created_at));
      if (this.post.author) parts.push(this.t('By') + ' ' + this.post.author);
      return parts.join(' · ');
    }
  },

  methods: {
    formatDate(isoString) {
      return new Date(isoString).toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    }
  },

  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          'Content Preview': 'Content Preview'
        },
        'zh-MY': {
          'Content Preview': '内容预览'
        },
        'ms-MY': {
          'Content Preview': 'Pratonton Kandungan'
        }
      }
    });

    return { t };
  }
};
</script>
